export const logger = {
  error: (message: string) => {
    console.error(message);
  }
};